import { FC, useContext } from 'react';
import WidgetContainer from '../../../UiLib/WidgetContainer/WidgetContainer';
import { TaskAddEditContext } from '../../../../contexts/TaslAddEditFormContext';
import Button from '../../../UiLib/Button/Button';
import HtmlPreview from '../../../UiLib/HtmlPreview/HtmlPreview';
import { TASK_DESC_LIMIT } from '../FormConstants/FormConstants';

import ExitCross from "../../../../assets/cancelGreey.svg";

const TaskFormOldMark: FC = () => {
    const taskAddEditFormContext = useContext(TaskAddEditContext)

    return (
        <WidgetContainer className="task__create--edit__form--old__mark">
            <div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <p style={{ width: "100%" }}>Старое отображение</p>
                    <Button callBack={() => taskAddEditFormContext.setOpenOldMark((prevState) => !prevState)} image={ExitCross} />
                </div>
                <div className="old-mark-style">
                    <HtmlPreview
                        content={
                            taskAddEditFormContext.taskOldMarkDesc?.length! > TASK_DESC_LIMIT
                                ? taskAddEditFormContext.taskOldMarkDesc?.slice(0, TASK_DESC_LIMIT)
                                : taskAddEditFormContext.taskOldMarkDesc
                        }
                    />
                </div>
            </div>
        </WidgetContainer>
    )
};

export default TaskFormOldMark;